module.exports = __webpack_public_path__ + "static/media/facebook.cec0cf9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CanvasPublished/facebook.svg
// module id = 693
// module chunks = 0